import React from "react";
import { FiChevronLeft } from "react-icons/fi";

const headerStyle = {
  alignItems: "center",
  background: "#fff",
  border: "1px solid #eef2f7",
  borderRadius: "10px",
  boxShadow: "0 10px 28px rgba(15, 23, 42, 0.08)",
  display: "flex",
  gap: "12px",
  marginBottom: "18px",
  padding: "12px 16px",
};

const backButtonStyle = {
  alignItems: "center",
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
  borderRadius: "8px",
  color: "#0f172a",
  display: "inline-flex",
  height: "36px",
  justifyContent: "center",
  lineHeight: 1,
  minWidth: "36px",
  padding: 0,
  transition: "all 0.2s ease",
  width: "36px",
};

const titleStyle = {
  color: "#0f172a",
  fontSize: "18px",
  fontWeight: 700,
  lineHeight: 1.25,
  margin: 0,
};

const actionsStyle = {
  alignItems: "center",
  display: "flex",
  gap: "10px",
  marginLeft: "auto",
};

const FormPageHeader = ({ title, onBack, children }) => (
  <div style={headerStyle}>
    {onBack ? (
      <button
        type="button"
        aria-label="Back"
        onClick={onBack}
        style={backButtonStyle}
        onMouseEnter={(event) => {
          event.currentTarget.style.background = "#fff1f2";
          event.currentTarget.style.borderColor = "#fecdd3";
          event.currentTarget.style.color = "#e11d48";
        }}
        onMouseLeave={(event) => {
          event.currentTarget.style.background = "#f8fafc";
          event.currentTarget.style.borderColor = "#e2e8f0";
          event.currentTarget.style.color = "#0f172a";
        }}
      >
        <FiChevronLeft size={22} />
      </button>
    ) : null}
    <h5 style={titleStyle}>{title}</h5>
    {children ? <div style={actionsStyle}>{children}</div> : null}
  </div>
);

export default FormPageHeader;
